import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService, EnlacesService, MenuService } from '@app/_services';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { FileInfo, FileRestrictions, SelectEvent, RemoveEvent } from '@progress/kendo-angular-upload';
import { first } from 'rxjs/operators';

import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-enlaces-detalle',
  templateUrl: './enlaces-detalle.component.html'
})
export class EnlacesDetalleComponent implements OnInit {

  form: FormGroup;
  codigo: number;
  isAddMode: boolean;
  imagenEnlace: any;
  public events: string[] = [];
  public imagePreview;
  loading = false;
  submitted = false;
  modalReference: NgbModalRef;
  imagenAnt: any;
  isNotIns = false;
  imagenBorrada = false;
  formImErr = false;

  regexLink = '^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$';
  public restrictions: FileRestrictions = {
    allowedExtensions: ['.png', '.jpeg', '.jpg'],
    maxFileSize: 1048576
  };

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer,
    private translateService: TranslateService,
    private enlacesService: EnlacesService,
    private alertService: AlertService,
    private menuService: MenuService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.menuService.titulo = this.translateService.instant('enlaces.enlaces');

    this.codigo = this.route.snapshot.params['id'];

    this.isAddMode = !this.codigo;

    this.form = this.formBuilder.group({
      codigo: this.route.snapshot.params['id'],
      nombre1: new FormControl('', [Validators.required]),
      nombre2: new FormControl('', [Validators.required]),
      link1: new FormControl('', [Validators.required, Validators.pattern(this.regexLink)]),
      link2: new FormControl('', [Validators.required, Validators.pattern(this.regexLink)]),
      imagen: new FormControl(''),
      activo: new FormControl(false)
    });

    if (!this.isAddMode) {
      this.enlacesService.GetById(this.codigo)
        .pipe()
        .subscribe((result) => {
          this.form = this.formBuilder.group({
            codigo: this.route.snapshot.params['id'],
            nombre1: new FormControl(result.data[0].nombre1, [Validators.required]),
            nombre2: new FormControl(result.data[0].nombre2, [Validators.required]),
            link1: new FormControl(result.data[0].link1, [Validators.required, Validators.pattern(this.regexLink)]),
            link2: new FormControl(result.data[0].link2, [Validators.required, Validators.pattern(this.regexLink)]),
            imagen: new FormControl(''),
            activo: new FormControl(result.data[0].activo)
          });

          if (result.data[0].imagen) {
            this.imagenEnlace = result.data[0].imagen;
            this.imagenAnt = result.data[0].imagen;
            this.createImageFromBase64(this.imagenEnlace);
          } else {
            this.imagenAnt = [];
            this.imagenEnlace = [];
          }

        });
    }
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      // TODO This as a workaround.
      this.menuService.titulo = this.translateService.instant('enlaces.enlaces');
    });
  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  onSubmit() {
    this.submitted = true;

    // reset alerts on submit
    this.alertService.clear();

    // stop here if form is invalid
    if (this.form.invalid || this.formImErr) {
      return;
    }

    this.loading = true;
    if (this.isAddMode) {
      this.crearEnlace();
    } else {
      this.updateEnlace();
    }
  }

  private crearEnlace() {
    // Caso tiene foto
    this.form.value.imagen = this.imagenEnlace;

    this.enlacesService.insert(this.form.value)
      .subscribe((result) => {
        if (!result.error) {
          this.alertService.success(this.translateService.instant('botones.creadocorrectamente'), { keepAfterRouteChange: true });
          this.router.navigate(['../'], { relativeTo: this.route });
        } else {
          this.alertService.error(this.translateService.instant('enlaces.errorcrear'));
          this.loading = false;
        }
      });
  }

  private updateEnlace() {
    var error = null;
    this.form.value.imagen = this.imagenEnlace;

    if (this.imagenBorrada) {
      // Caso de foto borrada
      this.enlacesService.deleteImagen(this.form.value).subscribe((result) => {
        if (result.error)
          error = result.error;
      });
    } else {
      if (this.imagenEnlace != this.imagenAnt && this.imagenEnlace != []) {
        // Caso de foto actualizada
        this.enlacesService.updateImagen(this.form.value).subscribe((result) => {
          if (result.error)
            error = result.descripcion;
        });
      }
    }

    // Caso actualización de otra información
    this.enlacesService.update(this.form.value)
      .pipe(first())
      .subscribe((result) => {
        if (!result.error && !error) {
          this.alertService.success(this.translateService.instant('botones.editadocorrectamente'), { keepAfterRouteChange: true });
          this.router.navigate(['../../'], { relativeTo: this.route });
        } else {
          this.alertService.error(this.translateService.instant('enlaces.erroreditar'));
          this.loading = false;
        }
      });
  }

  // Parte foto
  createImageFromBase64(image) {
    let objectURL = 'data:image/jpeg;base64,' + image;
    this.imagePreview = this.sanitizer.bypassSecurityTrustUrl(objectURL);
  }

  onClickEliminarImagen(content) {
    this.modalReference = this.modalService.open(content, { backdrop: 'static', size: 'lg', keyboard: false, centered: true });
  }

  eliminarImagen() {
    this.imagenBorrada = true;
    this.imagenEnlace = [];
    this.imagePreview = null;
    this.modalReference.close();
  }

  public selectEventHandler(e: SelectEvent): void {
    const that = this;

    e.files.forEach((file) => {

      if (!file.validationErrors) {
        this.formImErr = false;
        const reader = new FileReader();

        reader.onload = function (ev) {
          const image = {
            src: ev.target['result'],
            uid: file.uid
          };

          that.imagePreview = image.src.toString();

          that.imagenEnlace = image.src.toString().split(",", 2)[1];

          that.imagenBorrada = false;

          that.isNotIns = true;
        };
        reader.readAsDataURL(file.rawFile);
      } else {
        this.formImErr = true;
      }
    });
  }

  public removeEventHandler(e: RemoveEvent): void {
    this.formImErr = false;
    this.imagenEnlace = [];
    this.imagePreview = null;
  }

}
